import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ProductOption {
  label: string;
  price: number;
}

export interface CafeProduct {
  id: number;
  name: string;
  description: string;
  image: string;
  category: string;
  options: ProductOption[];

  // Selected option is handled by the component
  selectedOption?: ProductOption;
}

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  private productsUrl = 'assets/data/cafe.json';

  constructor(
    private http: HttpClient
  ) {}

  /**
   * Get all Liberica Café products
   */
  getProducts(): Observable<CafeProduct[]> {

    return this.http.get<CafeProduct[]>(
      this.productsUrl
    );

  }

}